import { Button, Modal } from 'antd';
import { useState } from 'react';
import More from '../Component/Routes/More/Index';
const NavBar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <buton onClick={showModal}>
      <div class="square-box  mx-5">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
      </buton>
      <Modal title="Basic Modal" footer={false} header={false} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <More />
      </Modal>
    </>
  );
};
export default NavBar;